import { render, staticRenderFns } from "./ArticleSelect.vue?vue&type=template&id=61710c87&"
import script from "./ArticleSelect.vue?vue&type=script&lang=js&"
export * from "./ArticleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports